import Header from './Header';

export default Header;


// WEBPACK FOOTER //
// ./src/modules/header/index.js